<!-- =========================================================================================
  File Name: FormWizardValidation.vue
  Description: Form wizard with validation
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vx-card title="Participation à formation" >

    <p>Remplir les champs pour envoyer une demande de participation à la formation <strong> {{formation}}</strong></p>

    <div class="mt-5">
      <form-wizard color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit">
        <tab-content title="Étape 1" class="mb-5"  :before-change="validateStep1">

          <!-- tab 1 content -->
          <form data-vv-scope="step-1">
          <div class="vx-row" v-if="compte">
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input type="email" label="Email"  v-model="emailCompte" class="w-full" name="emailCompte" v-validate="'required|email'" />
              <span class="text-danger">{{ errors.first('step-1.emailCompte') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input type="password"  v-validate="'min:6|max:10|required'" label="password" name="passwordCompte" v-model="passwordCompte" class=" w-full" />
              <span class="text-danger" >{{ errors.first('step-1.passwordCompte') }}</span>
            </div>
          </div>
          <div class="vx-row" v-if="!compte">
            <div class="flex flex-wrap items-center  ml-5">
                <vs-avatar :src="avatar" size="70px" class="mr-4 mb-4 ml-5" />
                <div>
                  <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                      <vs-button class="mr-4 mb-4" @click="$refs.updateImgInput.click()">Change Avatar</vs-button>
                      <vs-button type="border" color="danger" @click="avatar = null">Remove Avatar</vs-button>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
                
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Nom" v-model="firstName" class="w-full" name="first_name" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.first_name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Prenom"  v-model="lastName" class="w-full" name="last_name" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.last_name') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input type="email" label="Email"  v-model="email" class="w-full" name="email" v-validate="'required|email'" />
              <span class="text-danger">{{ errors.first('step-1.email') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Telephone"  v-model="telephone" class="w-full" name="telephone" v-validate="'required|numeric'" />
              <span class="text-danger">{{ errors.first('step-1.telephone') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Adresse"  v-model="adresse" class="w-full" name="adresse" v-validate="'required|alpha'" />
              <span class="text-danger">{{ errors.first('step-1.adresse') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-input label="Password"  v-model="password" class="w-full" name="password" v-validate="'min:6|max:10|required'" />
              <span class="text-danger">{{ errors.first('step-1.password') }}</span>
            </div>
            
          </div>
          <vs-row class="mt-5">
              
                  <vs-button class=" ml-5" color="warning" type="border" @click="compte=true">reset</vs-button>
                  <vs-button class=" ml-5" color="primary" type="border" @click="compte=false">creation de compte</vs-button>
             
          </vs-row>
          </form>
        </tab-content>

        <!-- tab 2 content -->
        <tab-content title="Étape 2" class="mb-5"  :before-change="validateStep2">
          <form data-vv-scope="step-2">
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <vs-input label="Domaine" disabled  v-model="domaine" class="w-full mt-4" name="domaine" v-validate="'required|alpha_spaces'" />
              <span class="text-danger">{{ errors.first('step-2.domaine') }}</span>

              <vs-input label="Formation" disabled  v-model="formation" class="w-full mt-4" name="formation" v-validate="'required|alpha_spaces'" />
              <span class="text-danger">{{ errors.first('step-2.formation') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <vs-textarea v-model="textarea" label="discription de votre connesonsse sur cette formation" name="textarea" class="md:mt-10 mt-6 mb-0" rows="3" v-validate="'required'" />
              <span class="text-danger">{{ errors.first('step-2.textarea') }}</span>
            </div>
          </div>
          </form>
        </tab-content>

        <!-- tab 3 content -->
        <tab-content title="Étape 3" class="mb-5"  :before-change="validateStep3">
          <form data-vv-scope="step-3">
          <div class="vx-row">
            
            <div class="vx-col md:w-1/2 w-full">
              <vs-select v-model="paiement" class="w-full select-large mt-5" label="Paiement">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in paiementOptions" class="w-full" />
              </vs-select>
            </div>
            <div class="vx-col md:w-1/2 w-full mt-5">
              <vs-select v-model="Paiementt" class="w-full select-large" label="Paiement">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in PaiementtOptions" class="w-full" />
              </vs-select>
            </div>
            
          </div>
          </form>
        </tab-content>
      </form-wizard>
    </div>

    
  </vx-card>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from "../../http/axios/index.js"
// For custom error message
import { Validator } from 'vee-validate';
import moduleformation from '@/store/formation/moduleformation.js'
import modulecandidat from '@/store/candidat/modulecandidat.js'

const dict = {
    
    custom: {
      
      
        first_name: {
            required: 'First name is required',
            alpha: "First name may only contain alphabetic characters"
        },
        last_name: {
            required: 'Last name is required',
            alpha: "Last name may only contain alphabetic characters"
        },
        email: {
            required: 'Email is required',
            email: "Please enter valid email"
        },
        job_title: {
            required: 'Job title name is required',
            alpha: "Job title may only contain alphabetic characters"
        },
        proposal_title: {
            required: 'Proposal title name is required',
            alpha: "Proposal title may only contain alphabetic characters"
        },
        event_name: {
            required: 'Event name is required',
            alpha: "Event name may only contain alphabetic characters"
        },
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    data() {
        return {
          candidat_id:'',
          obj:{},
          domaine:'',
          formation:'',
          avatar:null,
          candidats: [],
          emailCompte: "",
          passwordCompte: "",
          compte:true,
             telephone: "",
             adresse: "",
             password: "",
            firstName: "",
            lastName: "",
            email: "",
            paiement : "par espece",
            proposalTitle: "",
            jobTitle: "",
            textarea: "",
            eventName: "",
            eventLocation: "san-francisco",
            Paiementt: "totale",
            paiementOptions: [
                { text: "Par espece", value: "par espece" },
                { text: "Par chèque", value: "par chèque" },
                
            ],
            PaiementtOptions: [
                { text: "Totale", value: "totale" },
                { text: "Par tranche", value: "par tranche" },
                
            ],
            LocationOptions: [
                { text: "New York", value: "new-york" },
                { text: "Chicago", value: "chicago" },
                { text: "San Francisco", value: "san-francisco" },
                { text: "Boston", value: "boston" },
            ],
        }
    },
    computed: {
      /* formation(){
         
        //return   this.$store.state.formation.users[0].titre
        },*/
        //domaine(){
         //console.log('frfr',this.$store.state.formation)
         //return   this.$store.state.formation.users[0].nom_domaine
       // }
    },
    methods: {
      updateCurrImg(input) {
      
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader()
        reader.onload = e => {
          this.avatar = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
      this.change_image = true
      console.log("this.change_image",this.change_image)

    },
        validateStep1() {
          console.log(this.candidats)
            const user = this.candidats.find(tt => tt.email === this.emailCompte  & this.passwordCompte === tt.password)
            
            console.log('user',user)
            return new Promise((resolve, reject) => {
                this.$validator.validateAll('step-1').then(result => {
                   console.log(this.compte)
                  if(this.compte){
                    if (result) {
                        if(user){
                        this.candidat_id=user.id
                        resolve(true)}else {
                        reject("correct all values");
                    }
                      } else {
                      
                        reject("correct all values");
                    }}
                  if(!this.compte){
                    if (result) {
                        console.log(result)
                        resolve(true)
                    }
                       else {
                      
                        reject("correct all values");
                    }}
                })
            })
        },
        validateStep2() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll("step-2").then(result => {
                    if (result) {
                        resolve(true)
                    } else {
                        reject("correct all values");
                    }
                })
            })
        },
        validateStep3() {
            return new Promise((resolve, reject) => {
                this.$validator.validateAll("step-3").then(result => {
                    if (result) {
                        //alert("Form submitted!");
                        resolve(true)
                        if(!this.compte){
                         this.obj ={nom:this.firstName,prenom:this.lastName,email:this.email,password:this.password,adresse:this.adresse,mobile:this.telephone,avatar:this.avatar,description:this.textarea,formationId:this.$route.params.userId,etat:this.$route.params.userId,paiment:0}
                         this.$store.dispatch("candidat/addParticipationCandidat", this.obj)//.then(()   => {  this.$forceUpdate(); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('success', 'Added', 'successfully added') }).catch(err => { console.error(err); this.activeLoading = false; this.$vs.loading.close(); this.showMessage('danger', 'not Added', 'an error in add: '+ err) })
                        }
                        else{
                         this.obj ={candidat_id:this.candidat_id,description:this.textarea,etat:this.$route.params.userId,paiment:0}
                         console.log(this.obj)
                         this.$store.dispatch("candidat/addParticipationCandidat", this.obj)
                        }
                        this.$router.push("/formation").catch(() => {})
                        this.showDemandeSuccess()
                    } else {
                        reject("correct all values");
                    }
                })
            })
        },
        
          showDemandeSuccess() {
            this.$vs.notify({
              color: 'success',
              title: 'Demande de participation',
              text: 'Votre demande envoyer avec succès'
            })
            
          }
        
    },
    created(){
       console.log("*********candidat************")
    if(!modulecandidat.isRegistered) {
      this.$store.registerModule('candidat', modulecandidat)
      modulecandidat.isRegistered = true
    }
     /* if(!moduleformation.isRegistered) {
      this.$store.registerModule('formation', moduleformation)
      moduleformation.isRegistered = true
    }
    this.$store.dispatch("formation/fetchFormation",this.$route.params.userId)
    console.log("cv",this.$store.state.formation.users)*/
          axios.get(`http://127.0.0.1:8000/api/getformation_id/${this.$route.params.userId}`).then(resp => {
          console.log(resp.data[0].titre)
          this.formation=resp.data[0].titre
          this.domaine=resp.data[0].nom_domaine});
          axios.get("http://127.0.0.1:8000/api/getCandidat").then(resp => {
          this.candidats = resp.data});
    },
    components: {
        FormWizard,
        TabContent
    }
}
</script>
